export const PricingStrategyIds = {
	Fixed: '00000000-0000-0000-0000-000000000001',
	ConsecutiveStops: '00000000-0000-0000-0000-000000000002',
} as const;

export const PricingStrategys = {
	Fixed: 'Fixed',
	ConsecutiveStops: 'ConsecutiveStops',
} as const;

export type PricingStrategy = keyof typeof PricingStrategys;

export const getPricingStrategy = (pricingStrategyId?: string) => {
	switch (pricingStrategyId) {
		case PricingStrategyIds.Fixed:
			return PricingStrategys.Fixed;
		case PricingStrategyIds.ConsecutiveStops:
			return PricingStrategys.ConsecutiveStops;
		default:
			return PricingStrategys.Fixed;
	}
};
